import { deleteRequest, get, patch, post } from "./api";

const fetchTags = () => {
  return get(`/api/v2/resourcetags/`);
};

const updateTag = (tagID, data) => {
  return patch(`/api/v2/resourcetags/${tagID}/`, data, "multipart/form-data");
};

const createTag = (data) => {
  return post(`/api/v2/resourcetags/`, data, "multipart/form-data");
};

const deleteTag = (tagID) => {
  return deleteRequest(`/api/v2/resourcetags/${tagID}/`);
};

export { createTag, deleteTag, fetchTags, updateTag };

